module.exports = __webpack_public_path__ + "static/media/modal-selfie-2-desktop.9c67ae81.png";